import { useBotFlow } from '../../../../../../../../../store/flow'

export function useIsFuzzyQuestionAnswersModeOn(): boolean {
  const flow = useBotFlow()

  return flow?.stepTypeDefaults?.question?.fuzzyAnswers || false
}
